import { render, staticRenderFns } from "./CampaignsOverview.vue?vue&type=template&id=3d5179b0&scoped=true&"
import script from "./CampaignsOverview.vue?vue&type=script&lang=js&"
export * from "./CampaignsOverview.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsOverview.vue?vue&type=style&index=0&id=3d5179b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5179b0",
  null
  
)

export default component.exports